import {
  DevicePhoneMobileIcon,
  DocumentTextIcon,
  ChatBubbleLeftEllipsisIcon,
  WrenchScrewdriverIcon,
  ExclamationTriangleIcon,
  ArrowRightIcon,
} from '@heroicons/react/24/outline';

const painPoints = [
  { icon: DevicePhoneMobileIcon, label: 'Disconnected apps' },
  { icon: DocumentTextIcon, label: 'Paper notes' },
  { icon: ChatBubbleLeftEllipsisIcon, label: 'Text messages' },
  { icon: WrenchScrewdriverIcon, label: 'One-off safety products' },
  { icon: ExclamationTriangleIcon, label: 'Reactive decisions after something goes wrong' },
];

const WhatMakesDifferentSection = () => {
  return (
    <div className="py-20 lg:py-28 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground text-center mb-4">
            One Connected Support System,{' '}
            <span className="text-primary">Beyond the Patchwork</span>
          </h2>

          <p className="text-lg text-muted-foreground text-center leading-relaxed mb-12 max-w-2xl mx-auto">
            Most people trying to remain at home end up juggling all of this:
          </p>

          {/* Two-column contrast layout */}
          <div className="grid lg:grid-cols-2 gap-8 items-stretch">
            {/* Left: The patchwork problem */}
            <div className="relative p-8 rounded-md bg-background shadow-floating">
              <div className="absolute -top-3.5 left-6">
                <span className="bg-background text-destructive text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full">
                  The Patchwork
                </span>
              </div>
              <div className="space-y-3 mt-3">
                {painPoints.map((point) => (
                  <div
                    key={point.label}
                    className="flex items-center gap-3 p-3 rounded-lg bg-destructive/5"
                  >
                    <point.icon className="w-5 h-5 text-destructive/60 flex-shrink-0" />
                    <span className="text-muted-foreground text-sm">{point.label}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Right: The connected system */}
            <div className="relative p-8 rounded-md bg-gradient-to-br from-primary/5 to-primary/10 shadow-overlay">
              <div className="absolute -top-3.5 left-6">
                <span className="bg-primary text-primary-foreground text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full">
                  Why This Works Better
                </span>
              </div>
              <div className="mt-3 space-y-5">
                <p className="text-foreground leading-relaxed">
                  SeniorThrive replaces that fragmentation with one connected
                  experience that helps you:
                </p>
                <div className="space-y-3">
                  {['Stay focused on what matters day to day', 'Address small issues before they become big ones', 'Stay aligned with the people you trust'].map((item) => (
                    <div key={item} className="flex items-center gap-3">
                      <ArrowRightIcon className="w-4 h-4 text-primary flex-shrink-0" />
                      <span className="text-foreground font-bold">{item}</span>
                    </div>
                  ))}
                </div>
                <p className="text-primary font-bold text-lg pt-2">
                  Safety, wellness, and daily life, connected, not scattered.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatMakesDifferentSection;
